import { useState, useEffect } from 'react';
import { Bell, BellOff } from 'lucide-react';
import { pushNotificationService } from '../../lib/services/pushNotificationService';
import { useUserStore } from '../../lib/userStore';
import toast from 'react-hot-toast';

export function PushNotificationToggle() {
  const userId = useUserStore((state) => state.user_id);
  const userIdNum = userId ? parseInt(userId) : null;
  const [isEnabled, setIsEnabled] = useState(false);
  const [isSupported, setIsSupported] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Vérifier le support et l'état actuel
    const checkStatus = async () => {
      const supported = pushNotificationService.isSupported();
      setIsSupported(supported);

      if (supported) {
        const hasPermission = pushNotificationService.hasPermission();
        const isSubscribed = await pushNotificationService.isSubscribed();
        setIsEnabled(hasPermission && isSubscribed);
      }
    };

    checkStatus();
  }, []);

  const handleToggle = async () => {
    if (!userIdNum) {
      toast.error('Utilisateur non connecté');
      return;
    }

    setIsLoading(true);

    try {
      if (isEnabled) {
        // Désactiver les notifications
        const result = await pushNotificationService.unsubscribe(userIdNum);
        if (result.success) {
          setIsEnabled(false);
          toast.success('Notifications désactivées');
        } else {
          toast.error(result.error || 'Erreur lors de la désactivation');
        }
      } else {
        // Activer les notifications
        const result = await pushNotificationService.subscribe(userIdNum);
        if (result.success) {
          setIsEnabled(true);
          toast.success('Notifications activées !');
          
          // Envoyer une notification de test après 1 seconde
          setTimeout(async () => {
            try {
              await pushNotificationService.sendTestNotification();
            } catch (e) {
              console.error('Erreur test notification:', e);
            }
          }, 1000);
        } else {
          toast.error(result.error || 'Erreur lors de l\'activation');
        }
      }
    } catch (error: any) {
      console.error('Erreur toggle notifications:', error);
      toast.error(error.message || 'Erreur inattendue');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isSupported) {
    return null;
  }

  return (
    <div className="d-flex align-items-center gap-2" style={{ color: 'rgba(255,255,255,0.7)' }}>
      {isEnabled ? <Bell size={14} /> : <BellOff size={14} />}
      <label
        htmlFor="push-notif-toggle"
        className="form-check-label small mb-0"
        style={{ cursor: 'pointer', userSelect: 'none' }}
      >
        Notifications push
      </label>
      <div className="form-check form-switch mb-0">
        <input
          id="push-notif-toggle"
          className="form-check-input"
          type="checkbox"
          role="switch"
          checked={isEnabled}
          onChange={handleToggle}
          disabled={isLoading}
          style={{ cursor: 'pointer' }}
        />
      </div>
    </div>
  );
}
